export default __webpack_public_path__ + "/dist/images/8654361.jpg";